"use strict";
"use client";
import { jsx } from 'react/jsx-runtime';
import { createSlotRecipeContext } from '../../styled-system/create-slot-recipe-context.js';
import { ArrowUpIcon, ArrowDownIcon } from '../icons.js';

const {
  withProvider,
  withContext,
  useStyles: useStatStyles,
  PropsProvider
} = createSlotRecipeContext({ key: "stat" });
const StatRoot = withProvider(
  "dl",
  "root"
);
const StatPropsProvider = PropsProvider;
const StatLabel = withContext("dt", "label");
const StatValueText = withContext(
  "dd",
  "valueText"
);
const StatHelpText = withContext(
  "span",
  "helpText"
);
const StatValueUnit = withContext(
  "span",
  "valueUnit"
);
const StatUpIndicator = withContext(
  "span",
  "indicator",
  {
    defaultProps: {
      "data-type": "up",
      children: /* @__PURE__ */ jsx(ArrowUpIcon, {})
    }
  }
);
const StatDownIndicator = withContext("span", "indicator", {
  defaultProps: {
    "data-type": "down",
    children: /* @__PURE__ */ jsx(ArrowDownIcon, {})
  }
});

export { StatDownIndicator, StatHelpText, StatLabel, StatPropsProvider, StatRoot, StatUpIndicator, StatValueText, StatValueUnit, useStatStyles };
